// Pure search/filter helpers used by the topbar search box. Pulled out
// of App.tsx so the matching rules can be unit-tested without a DOM.
//
// The search is intentionally lenient: case-insensitive substring match
// across the most-asked-about fields (tenant name + owner + plan, or
// admin user name + email + roles). Stop-gap until tenant counts grow
// past ~200 and we move filtering server-side.

import type { Tenant } from "./types";
import type { AdminTeamMember } from "./api";

export function filterTenants(tenants: Tenant[], query: string): Tenant[] {
  const q = query.trim().toLowerCase();
  if (!q) return tenants;
  return tenants.filter((t) => tenantMatches(t, q));
}

export function tenantMatches(t: Tenant, qLower: string): boolean {
  return (
    t.name.toLowerCase().includes(qLower) ||
    t.owner.toLowerCase().includes(qLower) ||
    t.plan.toLowerCase().includes(qLower) ||
    t.id.toLowerCase().includes(qLower)
  );
}

export function filterAdminUsers(
  users: AdminTeamMember[],
  query: string,
): AdminTeamMember[] {
  const q = query.trim().toLowerCase();
  if (!q) return users;
  return users.filter((u) => adminUserMatches(u, q));
}

export function adminUserMatches(u: AdminTeamMember, qLower: string): boolean {
  return (
    u.email.toLowerCase().includes(qLower) ||
    u.fullName.toLowerCase().includes(qLower) ||
    (u.roleKeys ?? []).some((r) => r.toLowerCase().includes(qLower))
  );
}
